import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const TenantContext = createContext({});

export function TenantProvider({ children }) {
  const { user } = useAuth();
  const [tenant, setTenant] = useState(null);

  const recarregarTenant = useCallback(async () => {
    try {
      const { data } = await api.get('/tenant');
      setTenant(data);
    } catch {
    }
  }, []);

  useEffect(() => {
    if (user) {
      recarregarTenant();
    } else {
      setTenant(null);
    }
  }, [user, recarregarTenant]);

  // Formata datas de vencimento/próxima calibração respeitando formatoData do tenant.
  // Use APENAS para nextCalibrationDate / proximaData — não para datas de evento (data da calibração).
  const formatarData = useCallback((dateStr) => {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    if (isNaN(d)) return '—';
    if (tenant?.formatoData === 'MM/AAAA') {
      return d.toLocaleDateString('pt-BR', { month: '2-digit', year: 'numeric' });
    }
    return d.toLocaleDateString('pt-BR');
  }, [tenant?.formatoData]);

  // Returns true if the module is enabled for this tenant.
  // Empty modulosAtivos = all modules active (backward compat).
  const hasModule = useCallback((name) => {
    if (!tenant?.modulosAtivos || tenant.modulosAtivos.length === 0) return true;
    return tenant.modulosAtivos.includes(name);
  }, [tenant?.modulosAtivos]);

  return (
    <TenantContext.Provider value={{ tenant, recarregarTenant, formatarData, hasModule }}>
      {children}
    </TenantContext.Provider>
  );
}

export const useTenant = () => useContext(TenantContext);
